// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6eaeab50","86":"61cfcd19","126":"e34926a8","161":"5fe55a33","240":"3fe5589b","373":"10906166","464":"52a4c760","498":"adf34387","569":"e3a10a19","585":"0929b93d","643":"c71d4295","733":"2ac8daf6","793":"e9cbf64f","839":"8112f0b7","918":"4f5902d6"}[chunkId] + ".chunk.js";
};